"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[266],{

/***/ 7696:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/blog-main-visual.9e3abc48.png","height":808,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAD1BMVEULGTAGDRoNJEMWNFQBAwUsFtjnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nCXBsQEAMAyDMMD5/+YOlVA+3bbCk4oHAXcAIbhXQ7kAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 7406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ BlogMainSectionContainer; },
  "Z": function() { return /* binding */ Blog_BlogMainSection; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ./components/Blog/CategoryTab.tsx
var CategoryTab = __webpack_require__(3951);
// EXTERNAL MODULE: ./components/Blog/PostCard.tsx
var PostCard = __webpack_require__(4357);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ./react-query/blogHooks.ts + 1 modules
var blogHooks = __webpack_require__(640);
// EXTERNAL MODULE: ./context/BlogContext.tsx
var BlogContext = __webpack_require__(5304);
// EXTERNAL MODULE: ./components/Common/GlassLoader.tsx
var GlassLoader = __webpack_require__(9702);
// EXTERNAL MODULE: ./components/Blog/NoPost.tsx
var NoPost = __webpack_require__(9120);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/Blog/PostListSection.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  .card-list {\n    width: 100%;\n    display: grid;\n    grid-gap: 24px;\n    grid-template-columns: repeat(3, minmax(200px, 1fr));\n  }\n\n  @media screen and (max-width: 1239px) {\n    .card-list {\n      grid-gap: 16px;\n      grid-template-columns: repeat(2, minmax(200px, 1fr));\n    }\n  }\n\n  @media screen and (max-width: 599px) {\n    .card-list {\n      grid-template-columns: repeat(1, minmax(200px, 1fr));\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var PostListSection = function() {
    var locale = (0,router.useRouter)().locale;
    var ref = (0,blogHooks/* usePostList */.NO)(), postListRes = ref.data, isLoading = ref.isLoading, hasNextPage = ref.hasNextPage, fetchNextPage = ref.fetchNextPage, isFetchingNextPage = ref.isFetchingNextPage;
    var ref1 = (0,BlogContext/* useBlogContext */.F)(), prevScrollTop = ref1.state.prevScrollTop, dispatch = ref1.dispatch;
    var noPosts = (0,react.useMemo)(function() {
        if (isLoading) return false;
        var flatPosts = postListRes.pages.map(function(page) {
            return page.posts;
        }).flat().flat();
        return flatPosts.length === 0;
    }, [
        postListRes,
        isLoading
    ]);
    // 페이지로 돌아올 경우 스크롤 위치 회복
    (0,react.useEffect)(function() {
        if (prevScrollTop) window.scrollTo({
            top: prevScrollTop
        });
        dispatch({
            type: "change",
            newState: {
                prevScrollTop: 0
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostListSectionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlassLoader/* GlassLoader */.y, {
            loadingText: "Loading Posts..."
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostListSectionContainer, {
        children: [
            noPosts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoPost/* default */.Z, {
                text: {
                    en: "Matched result not found.",
                    ko: "검색 결과에 해당하는 글이 없습니다."
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "card-list",
                children: postListRes === null || postListRes === void 0 ? void 0 : postListRes.pages.map(function(page) {
                    return page.posts.map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                            title: post.title,
                            category: post.category,
                            publishedDate: post.date.date,
                            thumbnail: post.thumbnail || "",
                            postId: post.id,
                            forPostUI: false
                        }, post.id);
                    });
                })
            }),
            !noPosts && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                className: "p-b-btn",
                buttonType: isFetchingNextPage || !hasNextPage ? "disabled" : "default",
                onClick: function() {
                    return fetchNextPage();
                },
                text: locale === "en" ? isFetchingNextPage ? "Loading..." : hasNextPage ? "Load more" : "You are on last page." : isFetchingNextPage ? "로드중..." : hasNextPage ? "더 보기" : "마지막 페이지 입니다.",
                injectInlineStyles: {
                    height: "48px",
                    marginTop: "56px"
                },
                injectCssStyles: [
                    (0,breakPoints/* generateCssStyle */.m)({
                        width: hasNextPage ? "156px" : "fit-content",
                        padding: hasNextPage ? "0" : "0 32px"
                    }), 
                ]
            })
        ]
    });
};
/* harmony default export */ var Blog_PostListSection = (PostListSection);
var PostListSectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "PostListSection__PostListSectionContainer",
    componentId: "sc-1787ff91-0"
})(_templateObject());

// EXTERNAL MODULE: ./components/Blog/SearchArea.tsx
var SearchArea = __webpack_require__(7277);
;// CONCATENATED MODULE: ./components/Blog/BlogMainSection.tsx

function BlogMainSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .inner-container {\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1200px;\n      margin: 192px auto;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 96px;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 56px;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 32px;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 32px 16px;\n    }\n  }\n"
    ]);
    BlogMainSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BlogMainSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogMainSectionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTab/* default */.ZP, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchArea/* default */.ZP, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_PostListSection, {})
            ]
        })
    });
};
/* harmony default export */ var Blog_BlogMainSection = (BlogMainSection);
var BlogMainSectionContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "BlogMainSection__BlogMainSectionContainer",
    componentId: "sc-1b88d99c-0"
})(BlogMainSection_templateObject());


/***/ }),

/***/ 3951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ TabItem; },
/* harmony export */   "Nz": function() { return /* binding */ CategoryTabContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5304);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  display: flex;\n  justify-content: center;\n  @media screen and (max-width: 768px) {\n    justify-content: flex-start;\n    overflow-x: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      & > button {\n        background: ",
        ";\n        border: 1px solid ",
        ";\n        color: #fff;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  width: 120px;\n  height: 40px;\n  & > button {\n    border: 1px solid ",
        ";\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Noto Sans KR', sans-serif;\n    font-size: 14px;\n    line-height: 21px;\n    width: 100%;\n    height: 100%;\n    color: ",
        ";\n    transition: 0.2s all;\n    overflow: hidden;\n  }\n\n  ",
        ";\n\n  & + & {\n    margin-left: 12px;\n  }\n  &:hover > button {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var tabs = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Technology",
        value: "technology"
    },
    {
        label: "Media Trend",
        value: "media trend"
    },
    {
        label: "News",
        value: "news"
    }, 
];
var CategoryTab = function() {
    var ref = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_4__/* .useBlogContext */ .F)(), category = ref.state.category, dispatch = ref.dispatch;
    var handleChangeCategory = function(category) {
        return dispatch({
            type: "change",
            newState: {
                category: category,
                currPageNum: 1
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryTabContainer, {
        children: tabs.map(function(tab) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabItem, {
                isSelected: tab.value === category,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: function() {
                        return handleChangeCategory(tab.value);
                    },
                    children: tab.label
                })
            }, tab.value);
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (CategoryTab);
var CategoryTabContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "CategoryTab__CategoryTabContainer",
    componentId: "sc-9510c0b2-0"
})(_templateObject());
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "CategoryTab__TabItem",
    componentId: "sc-9510c0b2-1"
})(_templateObject2(), global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY70 */ .Q2, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY30 */ .zm, function(param) {
    var isSelected = param.isSelected;
    return isSelected && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), global_styles__WEBPACK_IMPORTED_MODULE_3__.BB, global_styles__WEBPACK_IMPORTED_MODULE_3__.BB);
}, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY20 */ .sF);


/***/ }),

/***/ 9120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9059);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NoPost = function(param) {
    var text = param.text;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NoPostContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__.H5, {
            children: text[locale]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoPost);
var NoPostContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "NoPost__NoPostContainer",
    componentId: "sc-c998993f-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY20 */ .sF);


/***/ }),

/***/ 4357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5564);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9059);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5505);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8966);
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 180px;\n      .pc-inner-container {\n        padding: 12px;\n      }\n      .pc-title {\n        font-size: 14px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #fff;\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n\n  .pc-inner-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    padding: 20px;\n  }\n  .info-area {\n    width: 100%;\n  }\n  .tn-wrapper {\n    width: 100%;\n    display: inline-block;\n    padding-top: 56.25%;\n    position: relative;\n    margin-bottom: 12px;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    overflow: hidden;\n  }\n  .tn-wrapper::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.3);\n    opacity: 0;\n    transition: 0.3s opacity ease-in;\n  }\n  .pc-cat {\n    color: ",
        ";\n    text-transform: capitalize;\n  }\n  .pc-title {\n    margin: 12px 0;\n    width: 100%;\n    overflow: hidden;\n    display: block;\n  }\n  .pc-title {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    color: ",
        ";\n  }\n  .pc-date {\n    color: ",
        ";\n  }\n\n  & img {\n    transition: 0.3s transform ease-in;\n  }\n  .pc-inner-container:hover {\n    cursor: pointer;\n    .pc-title > span {\n      text-decoration: underline;\n    }\n    img {\n      transform: scale(1.1);\n    }\n    .tn-wrapper::after {\n      opacity: 1;\n    }\n  }\n  @media screen and (min-width: 1240px) {\n    .pc-title {\n      font-size: 17px;\n    }\n  }\n  @media screen and (max-width: 1239px) {\n    .pc-inner-container {\n      padding: 20px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    .pc-inner-container {\n      padding: 16px;\n    }\n  }\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var PostCard = function(param) {
    var title = param.title, category = param.category, publishedDate = param.publishedDate, thumbnail = param.thumbnail, postId = param.postId, _forPostUI = param.forPostUI, forPostUI = _forPostUI === void 0 ? false : _forPostUI;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_7__/* .useBlogContext */ .F)().dispatch;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)().locale;
    var handleClickPostCard = function() {
        // list 에서의 scrollY 위치 기억하기
        var scrollY = window.scrollY;
        dispatch({
            type: "change",
            newState: {
                prevScrollTop: scrollY
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PostCardContainer, {
        forPostUI: forPostUI,
        onClick: handleClickPostCard,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: "/blog/post/".concat(postId),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                className: "pc-inner-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "tn-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__/* .ImgBackgroundWrapper */ .Yo, {
                            isNormalUse: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: thumbnail,
                                layout: "fill",
                                alt: title,
                                className: "target-img",
                                objectFit: "cover",
                                quality: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "info-area",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .BodyTextSStrong */ .dH, {
                                className: "pc-cat",
                                children: category
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .SubtitleM */ .sy, {
                                className: "pc-title",
                                children: title.replaceAll("&#8216;", "‘").replaceAll("&#8217;", "’")
                            }),
                            publishedDate && !forPostUI && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_3__/* .BodyTextS */ .Ei, {
                                className: "pc-date",
                                children: locale === "en" ? (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(publishedDate.slice(0, 10)), "yyyy-MM-dd") : (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(publishedDate.slice(0, 10)), "yyyy년 MM월 dd일")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);
var PostCardContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "PostCard__PostCardContainer",
    componentId: "sc-6859d5ea-0"
})(_templateObject1(), global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY90 */ .cW, global_styles__WEBPACK_IMPORTED_MODULE_3__.BB, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY20 */ .sF, global_styles__WEBPACK_IMPORTED_MODULE_3__/* .GRAY60 */ .Ts, function(param) {
    var forPostUI = param.forPostUI;
    return forPostUI === true && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 7277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IJ": function() { return /* binding */ OrderByOptionItemButton; },
/* harmony export */   "XP": function() { return /* binding */ SearchAreaContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5304);
/* harmony import */ var dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7622);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5505);
/* harmony import */ var _SearchForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7454);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0 32px;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'Noto Sans KR';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var orderValues = [
    {
        order: "DESC",
        orderBy: "post_view_count",
        label: "조회수 순",
        value: "post_view_count",
        en_label: "Sort by views"
    },
    {
        orderBy: "date",
        order: "ASC",
        label: "오래된 순",
        value: "date_asc",
        en_label: "Sort by oldest"
    },
    {
        orderBy: "date",
        order: "DESC",
        label: "최신 순",
        value: "date_desc",
        en_label: "Sort by newest"
    }, 
];
var getNextOrderValueByOrder = function(order, orderBy) {
    return orderValues.find(function(v) {
        return v.orderBy === orderBy && v.order === order;
    });
};
var SearchArea = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var ref = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_2__/* .useBlogContext */ .F)(), _state = ref.state, orderBy = _state.orderBy, order = _state.order, dispatch = ref.dispatch;
    var orderValue = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return getNextOrderValueByOrder(order, orderBy);
    }, [
        order,
        orderBy
    ]);
    var handleChangeOrder = function(e, value) {
        var nextOrderValue = orderValues.find(function(v) {
            return v.value === value;
        });
        dispatch({
            type: "change",
            newState: {
                orderBy: nextOrderValue.orderBy,
                order: nextOrderValue.order
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SearchAreaContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown */ .L, {
                disabled: false,
                changeStyle: true,
                displayBorder: false,
                onChange: handleChangeOrder,
                isPositionFixed: false,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.Toggle */ .L.Toggle, {
                        children: locale === "en" ? orderValue.en_label : orderValue.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.OptionList */ .L.OptionList, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.OptionItem */ .L.OptionItem, {
                                selected: "date_desc" === orderValue.value,
                                disabled: "date_desc" === orderValue.value,
                                value: "date_desc",
                                label: locale === "en" ? "Sort by newest" : "최신 순",
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OrderByOptionItemButton, {
                                    children: locale === "en" ? "Sort by newest" : "최신 순"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.OptionItem */ .L.OptionItem, {
                                selected: "date_asc" === orderValue.value,
                                disabled: "date_asc" === orderValue.value,
                                value: "date_asc",
                                label: locale === "en" ? "Sort by oldest" : "오래된 순",
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OrderByOptionItemButton, {
                                    children: locale === "en" ? "Sort by oldest" : "오래된 순"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown.OptionItem */ .L.OptionItem, {
                                selected: "post_view_count" === orderValue.value,
                                disabled: "post_view_count" === orderValue.value,
                                value: "post_view_count",
                                label: locale === "en" ? "Sort by views" : "조회수 순",
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OrderByOptionItemButton, {
                                    children: locale === "en" ? "Sort by views" : "조회수 순"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SearchForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SearchArea);
var SearchAreaContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SearchArea__SearchAreaContainer",
    componentId: "sc-6ad042d2-0"
})(_templateObject());
var OrderByOptionItemButton = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "SearchArea__OrderByOptionItemButton",
    componentId: "sc-6ad042d2-1"
})(_templateObject1());


/***/ }),

/***/ 7454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ SearchFormContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1089);
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5304);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9059);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 280px;\n  height: 48px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  display: flex;\n  & > * {\n    flex-shrink: 0;\n  }\n  & > input {\n    border-radius: 4px;\n    width: calc(100% - 44px);\n    border: none;\n    background: transparent;\n    padding-left: 12px;\n    color: ",
        ";\n    ::placeholder {\n      font-size: 15x;\n      line-height: 20px;\n      color: ",
        ";\n    }\n  }\n  & > input:focus {\n    outline: 1px solid ",
        ";\n  }\n  & > button {\n    width: 44px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  @media screen and (max-width: 599px) {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var SearchForm = function() {
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_3__/* .useBlogContext */ .F)().dispatch;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), searchDraft = ref[0], setSearchDraft = ref[1];
    var handleSubmit = function(e) {
        e.preventDefault();
        dispatch({
            type: "change",
            newState: {
                search: searchDraft,
                currPageNum: 1
            }
        });
    };
    var handleChange = function(e) {
        var target = e.target;
        var value = target.value;
        setSearchDraft(value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (searchDraft === "") dispatch({
            type: "change",
            newState: {
                search: ""
            }
        });
    }, [
        searchDraft,
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SearchFormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                type: "text",
                placeholder: locale === "en" ? "Enter keyword" : "검색어를 입력해주세요.",
                value: searchDraft,
                onChange: handleChange,
                spellCheck: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_2__/* .SearchIcon */ .W1, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchForm);
var SearchFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    displayName: "SearchForm__SearchFormContainer",
    componentId: "sc-dd0a7b82-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_4__/* .GRAYBG */ .lm, global_styles__WEBPACK_IMPORTED_MODULE_4__/* .GRAY70 */ .Q2, global_styles__WEBPACK_IMPORTED_MODULE_4__/* .GRAY30 */ .zm, global_styles__WEBPACK_IMPORTED_MODULE_4__/* .GRAY70 */ .Q2, global_styles__WEBPACK_IMPORTED_MODULE_4__/* .BBINDIGO */ ._4);


/***/ }),

/***/ 1924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Global_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6402);
/* harmony import */ var components_Popup_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(763);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5378);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .io-target {\n    position: absolute;\n    top: 0;\n    height: 60px;\n    width: 100%;\n    z-index: -1;\n  }\n  position: fixed;\n  z-index: 99;\n  bottom: 56px;\n  text-align: right;\n  right: 32px;\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    bottom: 32px;\n    right: 32px;\n  }\n  @media screen and (max-width: 599px) {\n    bottom: 32px;\n    right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FloatingController = function(param) {
    var isVisible = param.isVisible;
    var ref = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_4__/* .useContactModal */ .s)(), isContactModalOpen = ref.isContactModalOpen, handleCloseContactModal = ref.handleCloseContactModal, handleOpenContactModal = ref.handleOpenContactModal;
    var handleClickScrollBtn = function() {
        if (!isVisible) (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__/* .scrollTo */ .X5)(window, {
            top: 0,
            behavior: "smooth"
        });
        else {
            var $aboutMainBanner = document.querySelector(".main-section-container");
            if ($aboutMainBanner) {
                var scrollValue = $aboutMainBanner.getBoundingClientRect().height;
                (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_5__/* .scrollTo */ .X5)(window, {
                    top: scrollValue,
                    behavior: "smooth"
                });
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FloatingControllerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ScrollButton */ .xE, {
                isOpenContact: isContactModalOpen,
                isScrolled: !isVisible,
                onClick: handleClickScrollBtn
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ContactButton */ .AI, {
                onClick: handleOpenContactModal
            }),
            isContactModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Popup_index__WEBPACK_IMPORTED_MODULE_3__/* .ContactPopup */ .rb, {
                handleCloseContact: handleCloseContactModal
            })
        ]
    });
};
var FloatingControllerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FloatingController__FloatingControllerContainer",
    componentId: "sc-6a16d34b-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (FloatingController);


/***/ }),

/***/ 9702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ GlassLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5505);
/* harmony import */ var react_loader_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8756);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  flex-direction: column;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GlassLoader = function(param) {
    var loadingText = param.loadingText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(GlassLoaderContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loader_spinner__WEBPACK_IMPORTED_MODULE_3__/* .MagnifyingGlass */ .Yt, {
                visible: true,
                height: "100",
                width: "100",
                ariaLabel: "MagnifyingGlass-loading",
                wrapperStyle: {},
                wrapperClass: "MagnifyingGlass-wrapper",
                glassColor: "#c0efff",
                color: global_styles__WEBPACK_IMPORTED_MODULE_2__/* .BBBright */ .DS
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__.H5, {
                children: loadingText
            })
        ]
    });
};
var GlassLoaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "GlassLoader__GlassLoaderContainer",
    componentId: "sc-deed26d0-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY20 */ .sF);


/***/ })

}]);